import React, { useEffect, useState } from "react";
import img from "../../Images/image (24).png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeService from "../../Services/HomeService";
const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);

  const fetchTestimonials = async () => {
    try {
      const res = await HomeService?.getTestimonial();
      console.log("testimonials", res);
      if (res?.status) {
        setTestimonials(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const PrevArrow = ({ onClick }) => (
    <div className="arrow_div1" onClick={onClick}>
      <i class="fa-solid fa-arrow-left"></i>
    </div>
  );
  const NextArrow = ({ onClick }) => (
    <div className="arrow_div2" onClick={onClick}>
      <i class="fa-solid fa-arrow-right"></i>
    </div>
  );
  var settings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  const SliderData = [
    {
      author: "John D",
      proffession: "Creator",
      review:
        " Waystay transformed our property's value from $8 million to a record- breaking $12 million in under three weeks.They identifiedkey areas for improvement and made cost - effective changes that maximized the home's market value. Their expertise and efficiency delivered truly exceptional results.",
    },
    {
      author: "John M",
      proffession: "Creator",
      review:
        " Waystay transformed our property's value from $8 million to a record- breaking $12 million in under three weeks.They identifiedkey areas for improvement and made cost - effective changes that maximized the home's market value. Their expertise and efficiency delivered truly exceptional results.",
    },
  ];
  return (
    <>
      <div className="slider_wrapper">
        <div className="search_cities_div">
          <div className="slider_head">
            <h4>What People Are Saying</h4>
            <div className="arrow_wrapper"></div>
          </div>
          <Slider {...settings}>
            {testimonials?.map((e, i) => {
              return (
                <>
                  <div
                    className="slider_div"
                    style={{
                      paddingRight: "20px",
                    }}
                  >
                    <div className="left_slide_content">
                      <p>{e?.heading}</p>
                      <h3>{e?.name}</h3>
                      <h5>{e?.designation}</h5>
                    </div>
                    <div className="right_slide_img">
                      <img src={e?.image} />
                    </div>
                  </div>
                </>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Testimonial;
